<template>
  <div
    class="bg-white rounded box-shadow p-3 mb-1"
    style="padding-bottom:1px !important"
  >
    <div class="row">
      <div v-if="show"
        class="alert alert-danger alert-dismissible fade show"
        role="alert"
      >
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br />
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h5 class="float-left">02. Household Information</h5>
      </div>
      <div class="col">
        <b-button
          v-b-modal.tree-modal
          type="button"
          class="btn btn-success float-right btn-sm mb-1 text-black float-right"
          @click="$bvModal.show('household-modal'), resetForm()"
        >
          Add Household
          <i class="fas fa-plus"></i>
        </b-button>
      </div>
    </div>

    <div class="scrollable-table">
      <table
        class="table table-bordered table-hover dt-table table-striped table-long table-sm "
      >
        <thead>
          <tr>
            <th>#</th>
            <th>HH Name</th>
            <th>Relation</th>
            <th>Gender</th>
            <th>Age</th>
            <th>Education</th>
            <th>Marital Status</th>
            <th>Main Occupation</th>
            <th>Secondary Occupation</th>
            <th>Annual Income</th>
            <th>IS HH</th>
            <th>Disability</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr li v-for="(househ, index) in households" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ househ.full_name }}</td>
            <td>{{ househ.family_relation.desc }}</td>
            <td>{{ househ.gender.desc }}</td>
            <td>{{ househ.age }}</td>
            <td>{{ househ.education.desc }}</td>
            <td>{{ househ.maritial_status.desc }}</td>
            <td>{{ househ.occupation.desc }}</td>
            <td>
              <span v-for="(occu, index) in househ.sec_occupations" :key="index"
                >{{ occu.desc }}
                {{ index + 1 != househ.sec_occupations.length ? " ," : "" }}
              </span>
            </td>
            <td>{{ househ.yearly_income }}</td>
            <td>
              <span v-if="househ.is_household_head == 1">Yes</span>
              <span v-if="househ.is_household_head == 0">No</span>
            </td>
            <td>
              <span v-if="househ.is_disable == 1">Yes</span>
              <span v-if="househ.is_disable == 0">No</span>
            </td>
            <td>
              <b-button
                size="sm"
                variant="warning"
                class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                @click.prevent="
                  resetForm(),
                    getHholdMember(househ.id),
                    $bvModal.show('household-modal')
                "
              >
                <i class="far fa-edit"></i>
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                class="btn btn-warning btn-xs waves-effect waves-light"
                @click.prevent="softDelete(househ.id)"
              >
                <i class="far fa-trash-alt"></i>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <modal-create-household
      :household="household"
      :btn_edit="btn_edit"
      @getPersonHhold="getPersonHhold"
      @getCensusInfo="getCensusInfo"
      @resetForm="resetForm"
    ></modal-create-household>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

import appConfig from "@src/app.config";
import http from "@state/http";

import ModalCreateHousehold from "../../modals/ModalCreateHousehold";

export default {
  name: "house-hold",
  props: [],
  page: {
    title: "Fill up SES Form/House Hold",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Datepicker, Multiselect, ModalCreateHousehold },
  data() {
    return {
      title: "HouseHold Information",
      items: [
        {
          text: "Socio Economic Survey",
          href: "/ses/house-hold/"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      households: [],
      household: {},
      btn_edit: false,
      validation_errors: {},
      show: false
    };
  },

  mounted() {
    this.household.ses_id = this.$route.params.ses_id;
    this.getPersonHhold();
  },
  methods: {
    resetForm() {
      this.btn_edit = false;
      this.household = {};
      this.household.ses_id = this.$route.params.ses_id;
    },

    getHholdMember(id) {
      this.btn_edit = true;
      http.get("api/ses/households/" + id + "/edit").then(response => {
        if (!response.data.error) {
          this.household = response.data.houseHold;
        }
      });
    },

    getCensusInfo(ses_id) {
      http.get("api/seses/" + ses_id).then(response => {
        this.household = {};
        this.household.ses_id = ses_id;
        if (!response.data.error) {
          delete this.household.id;
          this.household.full_name = response.data.ses.name;
          this.household.c_family_relation_id = 1;
          this.household.c_gender_id = response.data.ses.c_gender_id;
          this.household.c_marital_status_id =
            response.data.ses.c_marital_status_id;
          this.household.c_occupation_id = response.data.ses.c_occupation_id;
          this.household.c_education_id = response.data.ses.c_education_id;
          this.household.yearly_income = response.data.ses.yearly_income;
          this.household.is_household_head =
            response.data.ses.is_household_head;
          this.household.is_disable = response.data.ses.is_disable;

          var changedFormate = moment(
            response.data.ses.dob,
            "YYYY/MM/DD"
          ).format("YYYY-MM-DD");
          var age = moment().diff(changedFormate, "years");
          this.household.age = age;
        }
      });
    },

    softDelete(hh_id) {
      http.delete("api/ses/households/" + hh_id).then(response => {
        if (!response.error) {
          this.getPersonHhold();
          this.$bvToast.toast(response.data.message, {
            title: "Success",
            autoHideDelay: 5000,
            variant: "success"
          });
        }
      });
    },

    getPersonHhold() {
      http.get("api/ses/households/" + this.household.ses_id).then(response => {
        if (!response.error) {
          this.households = response.data.houseHold;
        }
      });
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.custom-select {
  -webkit-appearance: unset;
}
.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}
.multiselect__tags {
  border-color: #ced4da;
  border-radius: 3px;
  min-height: 30px;
  padding: 4px 25px 0px 10px;
  margin-bottom: 0;
}
.multiselect__tag {
  margin-bottom: 0px;
}
.multiselect__placeholder {
  margin-bottom: 0px;
}
.multiselect__select {
  height: 30px;
}
.custom-select {
  color: #6c757d !important;
}
</style>
